import styled from 'styled-components';
import React from 'react';
import { Popover, OverlayTrigger } from 'react-bootstrap';

import { HelpIcon } from 'components/atoms/HelpIcon';

const ToggleCircle = styled.div`
    background: white;
    width: 25px;
    height: 25px;
    border-radius: 50%;
    transition: transform .4s;
    transform: translateX(${props => (props.value ? '100%' : '0')});
`;

const ToggleTrack = styled.div`
  display: flex;
  background: ${props => (props.value ? (props.color || props.theme.colors.primary) : props.theme.colors.lightgray)};
  border: 1px solid ${props => props.theme.colors.lightgray};
  min-width: 58px;
  height: 30px;
  border-radius: 50px;
  padding: 0 3px;
  align-items: center;
  transition: background .2s ease-in;
  cursor: pointer;
  transform: scale(${props => (props.scale ? props.scale : 1)});
`;

const ToggleWrapper = styled.div`
    display: flex;
    flex-direction: row;
`;


function ToggleSwitch({ input = {}, ...props }) {
    let onClick = props.onClick;

    const helpTextComponent = (<Popover id="layer-aliases" placement="right" title={props.helpTextTitle}>{props.helpText}</Popover>);

    // allows for this to work with redux-form
    if (!props.onClick && input.onChange && input.onBlur) {
        onClick = () => {
            input.onChange(!input.value);
        };
    }
    const value = input.value ? input.value : props.value;

    return (
        <ToggleWrapper>
            <ToggleTrack {...input} onClick={onClick} value={value} scale={props.scale} color={props.color}>
                <ToggleCircle value={value} />
            </ToggleTrack>
            {
                !!props.helpText &&
                <OverlayTrigger trigger="click" placement="right" overlay={helpTextComponent}>
                    <HelpIcon />
                </OverlayTrigger>
            }
        </ToggleWrapper>
    );
}

export default ToggleSwitch;



// WEBPACK FOOTER //
// ./src/components/atoms/form/ToggleSwitch.js